module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy-1"
  }, [_vm._v("First published in Great Britain 2017")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2"
  }, [_vm._v("Search Press Limited")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Wellwood, North Farm Road,")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Tunbridge Wells, Kent TN2 3DR")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2"
  }, [_vm._v("Text copyright © Sian Brown 2017")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2"
  }, [_vm._v("Photographs by Fiona Murray")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2"
  }, [_vm._v("Photographs and design copyright")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("© Search Press Ltd. 2017")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2"
  }, [_vm._v("All rights reserved. No part of this book, text, photographs or illustrations may be reproduced or transmitted in any form or by any means by print, photoprint, microfilm, microfiche, photocopier, Internet or in any way known or as yet unknown, or stored in a retrieval system, without written permission obtained beforehand from Search Press.")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2"
  }, [_vm._v("Print ISBN: 978-1-78221-239-3")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("eISBN: 978-1-78126-570-3")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2"
  }, [_vm._v("Publisher’s Note")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("The Publishers and author can accept no responsibility for any consequences arising from the information, advice or instructions given in this publication.")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2"
  }, [_vm._v("Readers are permitted to reproduce any of the items in this book for their personal use, or for the purposes of selling for charity, free of charge and without the prior permission of the Publishers. Any use of the items for commercial purposes is not permitted without the prior permission of the Publishers.")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2"
  }, [_vm._v("Suppliers")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("If you have difficulty in obtaining any of the materials and equipment mentioned in this book, then please visit the Search Press website for details of suppliers:")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.searchpress.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.searchpress.com")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f8513ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Copyright.vue
// module id = 69
// module chunks = 0